import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { useState } from 'react';
import useImageLoaded from '../hooks/useImageLoaded';
import ContentCard from './ContentCard';
import Spinner from './Spinner';
const ImageContentCard = ({ link, src, alt, onClose, children, }) => {
    // Handle image visibility
    const { ref, state } = useImageLoaded();
    const imgClasses = classNames('relative object-cover object-center w-full h-full transition-opacity duration-500', state === 'loaded' ? 'opacity-100' : 'opacity-0');
    // Handle spinner visibility
    const [showSpinner, setShowSpinner] = useState(state === 'loading');
    const handleTransitionEnd = () => {
        if (showSpinner && state === 'loaded')
            setShowSpinner(false);
    };
    return (_jsx(ContentCard, { onClose: onClose, closeClasses: "bg-white shadow top-4 right-4 tablet-portrait:shadow-none laptop:shadow", children: _jsx("a", { href: link, className: "group", role: "link", children: _jsxs("div", { className: "grid tablet-portrait:grid-cols-2 laptop:grid-cols-1", children: [_jsx("div", { className: "relative pt-[50%] mobile:pt-[60%] tablet-portrait:pt-0 laptop:pt-[67%]", children: _jsxs("div", { className: "absolute inset-0 bg-grey-50", children: [showSpinner && (_jsx("div", { className: "absolute inset-0 flex items-center justify-center", children: _jsx(Spinner, {}) })), _jsx("img", { ref: ref, src: src, alt: alt, className: imgClasses, onTransitionEnd: handleTransitionEnd })] }) }), children] }) }) }));
};
export default ImageContentCard;
